import { apiClient, requireAccessToken } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import { config } from '@/core/config'
import type { EntityDocument } from '@/api/types'

export class EntityDocumentService {
  async getByRef(tableName: string, tableRowId: number): Promise<EntityDocument[]> {
    const url = endpoints.entityDocument.getByRef(tableName, tableRowId)
    const res = await apiClient.get<EntityDocument[] | { data: EntityDocument[] }>(url, {
      skipHandledLocallyErrorUI: true,
    } as any)
    const raw = res.data
    if (Array.isArray(raw)) return raw
    if (raw && typeof raw === 'object' && 'data' in raw) return (raw as { data: EntityDocument[] }).data ?? []
    return []
  }

  async addDocument(formData: FormData): Promise<unknown> {
    const baseUrl = config.api.baseUrl?.replace(/\/$/, '') || ''
    const path = endpoints.entityDocument.add
    const url = `${baseUrl}${path.startsWith('/') ? path : '/' + path}`
    const token = requireAccessToken()
    const headers: HeadersInit = { Accept: 'application/json', Authorization: `Bearer ${token}` }
    const res = await fetch(url, { method: 'POST', body: formData, headers })
    const body = await res.json().catch(() => ({}))
    if (!res.ok || body?.isError) {
      throw Object.assign(new Error(body?.msg ?? body?.message ?? body?.Message ?? 'Add document failed'), {
        response: { status: res.status, data: body },
      })
    }
    return body
  }

  async deleteDocument(documentId: number): Promise<void> {
    const url = endpoints.entityDocument.delete(documentId)
    await apiClient.delete(url, { skipHandledLocallyErrorUI: true } as any)
  }
}

export const entityDocumentService = new EntityDocumentService()
